export default {
  'contact.title': 'Contact',
  'contact.titleHighlight': 'Me',
  'contact.subtitle': '共同研究・開発のご相談やお問い合わせはお気軽にどうぞ',

  // Info Section
  'contact.info.title': 'お問い合わせ情報',
  'contact.info.email': 'メール',
  'contact.info.affiliation': '所属',
  'contact.info.affiliationText': '東京大学大学院\n学際情報学府学際情報学専攻\n博士課程',
  'contact.info.lab': '研究室',
  'contact.info.labText': '矢谷研究室\n(Interactive Intelligent Systems Lab)',

  // Common Inquiries
  'contact.inquiries.title': 'よくあるご相談',
  'contact.inquiries.xr': 'XR技術を活用した研究開発',
  'contact.inquiries.edtech': '教育技術・EdTechソリューション',
  'contact.inquiries.gamification': 'ゲーミフィケーション導入',
  'contact.inquiries.hci': 'HCI研究・共同開発',
  'contact.inquiries.consulting': '技術コンサルティング',

  // Social
  'contact.social.title': 'SNSでもつながりましょう',

  // Form
  'contact.form.name': 'お名前',
  'contact.form.namePlaceholder': '山田太郎',
  'contact.form.email': 'メールアドレス',
  'contact.form.emailPlaceholder': 'example@company.com',
  'contact.form.organization': '所属・組織名',
  'contact.form.organizationPlaceholder': '○○大学 / 株式会社○○',
  'contact.form.subject': '件名',
  'contact.form.subjectPlaceholder': '共同研究について',
  'contact.form.message': 'メッセージ',
  'contact.form.messagePlaceholder': 'お問い合わせ内容をお聞かせください（500文字以内）',
  'contact.form.charCount': '{{count}}/500文字',
  'contact.form.required': '*',

  // Buttons
  'contact.form.submitting': '送信中...',
  'contact.form.submit': 'メッセージを送信',

  // Status Messages
  'contact.form.success': 'お問い合わせありがとうございます。できるだけ早くご返信いたします。',
  'contact.form.error': '送信に失敗しました。しばらく時間をおいて再度お試しください。',
};
